var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('service-toolbar'),(_vm.$store.service.id)?_c('expense-table',{attrs:{"heading":"Expenses","heading-small":'Service #'+_vm.$store.service.job_num+', '+_vm.$store.service.job_name,"show-user":true,"show-job":false,"editable":true,"filtering-tools":true,"filters":_vm.expenseFilters}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }